import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';

import MyTIContent from './Content';
import type { MyTIProps } from './interfaces';

const queryClient = new QueryClient();

const MyTI = ({
  env,
  forumPosts,
  initialCurrentUser,
  isGdprRequired,
  isWebview,
  newsletterNames,
}: MyTIProps) => {
  const { Track } = useEventTracking({
    page: Page.MyTI,
  });

  return (
    <AppContextProvider
      env={env}
      initialCurrentUser={initialCurrentUser}
      isGdprRequired={isGdprRequired}
      isWebview={isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <Track>
          <MyTIContent
            forumPosts={forumPosts}
            initialCurrentUser={initialCurrentUser}
            newsletterNames={newsletterNames}
          />
        </Track>
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default MyTI;
